module.exports = __webpack_public_path__ + "img/image7.9b4daaa0.jpeg";